import { Box } from 'rebass'
import { withTheme } from 'styled-components'
import { height, borderRadius, border, display, space } from 'styled-system'
import { observer } from 'mobx-react-lite'
const getSizeAttributes = props => {
  switch (props.size) {
    case 'sm':
      return {
        height: props.mini ? '30px' : [2, 1]
      }
    case 'large':
      return {
        height: props.mini ? '30px' : [4, 3]
      }
    default:
      return {
        height: props.mini ? '30px' : [3, 2]
      }
  }
}

const Select = withTheme(
  observer(props => {
    const sizeProps = getSizeAttributes(props)
    return (
      <Box
        css={[
          `
        position: relative;
        :after {
            content: "\\e90b";
            font-family: 'zen-icomoon' !important;
            font-size: ${props.iconFontSize || '18px'};
            display: block;
            pointer-events: none;
            position: absolute;
            right: ${props.iconRight || '5px'};
            top: ${props.iconTop || '50%'};
            margin-top: ${props.iconTop ? 0 : '-9px'};
            color: #3d3b3b;
            ${props.active ? `color: ${props.theme.colors.primary};` : ''}
        }`
        ]}>
        <Box
          as='select'
          {...props}
          {...sizeProps}
          css={[
            `
          display: inline-flex;
          align-items: center;
          padding: 5px 10px;
          outline: none;
          appearance: none;
          transition: all .1s;
          font-family: inherit;
          border: ${
      props.error
        ? `1px solid ${props.theme.colors.red.default} !important`
        : `1px solid ${props.theme.borders.grey[2]}`
      };
                font-weight: ${props.fontWeight || 'normal'};
                cursor: ${props.pointer ? 'pointer !important' : 'default'};
                :focus {
                  box-shadow: ${props.theme.shadows[2]};
                }
                ${
      props.active
        ? `color: ${props.theme.colors.primary}; border-color: ${props.theme.colors.primary} !important;`
        : ''
      }
                &:hover {
                    box-shadow: 0 0 8px 0 rgba(0,0,0,0.15);
                    
                }
                ${props.value === '' ? `color: ${props.theme.colors.grey.cool}` : ''}
          `,
            height,
            border,
            display,
            borderRadius
          ]}
        />
      </Box>
    )
  })
)

Select.defaultProps = {
  color: 'grey.0',
  bg: 'white.default',
  border: 'grey.2',
  borderRadius: 1,
  // fontSize: ['l', 's']
  fontSize: 's'
}

export default Select
